const TurnaroundIndex = () => import("@/pages/lab/turnaround/TurnaroundIndex");
const TurnaroundDetail = () =>
  import("@/pages/lab/turnaround/TurnaroundDetail");
const TurnaroundAdd = () => import("@/pages/lab/turnaround/TurnaroundAdd");
const TurnaroundEdit = () => import("@/pages/lab/turnaround/TurnaroundEdit");
const TurnaroundSingle = () =>
  import("@/pages/lab/turnaround/TurnaroundSingle");

export class TurnaroundRoutes {
  constructor() {
    this.route_root = "turnarounds";
    this.type_single = "Turnaround";
    this.type_plural = "Turnarounds";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: TurnaroundIndex,
            meta: { requiresAuth: true },
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: TurnaroundAdd,
            meta: { requiresAuth: true },
          },
          {
            path: ":turnaround_id",
            component: TurnaroundSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: TurnaroundDetail,
                meta: { requiresAuth: true },
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: TurnaroundEdit,
                meta: { requiresAuth: true },
              },
            ],
          },
        ],
      },
    ];
  }
  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }
  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
